import React from "react";

const DownloadAppSection = () => {
  return (
    <>
      <div className="dashboard__container__header">
        <h1 className="dashboard__container__header__heading">
          Looks like everything is{" "}
          <span className="dashboard__container__header__heading__span">
            good.
          </span>
        </h1>
        <p className="dashboard__container__header__paragraph">
          Download the app where you'll start your operations.
        </p>
        <a href="https://play.google.com/store/apps/details?id=com.meshdesh.just_6_sets">
          <button className="btn btn-md dashboard__container__header__button">
            Download App
          </button>
        </a>
      </div>
      <hr className="dashboard__container__hr" />
    </>
  );
};

export default DownloadAppSection;
